import { AutogenModelPartialShipmentPlanningManifestStopDetails, AutogenRowPartialShipmentPlanningManifestStopDetails } from "./autogen/AutogenModelPartialShipmentPlanningManifestStopDetails";

export class ModelPartialShipmentPlanningManifestStopDetails extends AutogenModelPartialShipmentPlanningManifestStopDetails<RowPartialShipmentPlanningManifestStopDetails> {
	constructor() {
		super(RowPartialShipmentPlanningManifestStopDetails);
	}
}

export class RowPartialShipmentPlanningManifestStopDetails extends AutogenRowPartialShipmentPlanningManifestStopDetails {
}